import { useOptimizelyFeatureFlag } from '@shared/v2/contexts/optimizely';

export const VARIATIONS = {
  show_primary_only: 'show_primary_only',
  show_primary_and_secondary: 'show_primary_and_secondary',
  off: 'off',
};

export const useHomepageHero = () => {
  const [decision, clientReady] = useOptimizelyFeatureFlag(
    'qantas-holidays-homepage-hero',
  );

  return {
    decision,
    isReady: clientReady,
    off: decision.variationKey === VARIATIONS.off,
    showPrimaryOnly: decision.variationKey === VARIATIONS.show_primary_only,
    showPrimaryAndSecondary:
      decision.variationKey === VARIATIONS.show_primary_and_secondary,
  };
};
